import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import {
  getFeatureClicks,
  getFeatureViewsByUser,
  resetFeatureClicks,
  resetFeatureViewsByUser,
} from "store/actions"
import { generateChartDataLastXDays } from "../utils"
import UserList from "../userList"
import { URL_PATHS } from "constants/index"

const CameraReport = ({
  history,
  getFeatureClicks,
  resetFeatureClicks,
  getFeatureViewsByUser,
  resetFeatureViewsByUser,
  featureClicks,
  featureViewsByUser,
  match,
}) => {
  const { event_id } = match?.params

  useEffect(() => {
    getFeatureClicks({
      event_id: event_id,
      feature: "camera",
    })
    getFeatureViewsByUser({
      event_id: event_id,
      feature: "camera",
      page: 1,
      per_page: 10,
    })
    return () => {
      resetFeatureClicks()
      resetFeatureViewsByUser()
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Camera" />
          <BreadcrumbTitle
            title={"Camera"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Camera" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {/* <Card>
            <CardBody>
              <Row>
                <Col
                  xl="3"
                  className="d-flex justify-content-between flex-column"
                >
                  <Row>
                    <Card
                      className="shadow-sm"
                      style={{
                        height: "115px",
                        border: "1px solid Gainsboro",
                      }}
                    >
                      <Row
                        className="d-flex align-items-center text-center"
                        style={{ height: "100%" }}
                      >
                        <Col xs="5">
                          <h6>Total Views</h6>
                          <i className="mdi mdi-eye font-size-18" />
                        </Col>
                        <Col>
                          {!!featureClicks?.total_views
                            ? featureClicks?.total_views
                            : "-"}
                        </Col>
                      </Row>
                    </Card>
                  </Row>
                  <Row>
                    <Card
                      className="shadow-sm"
                      style={{
                        height: "115px",
                        border: "1px solid Gainsboro",
                      }}
                    >
                      <Row
                        className="d-flex align-items-center text-center"
                        style={{ height: "100%" }}
                      >
                        <Col xs="5">
                          <h6>Percentage of Views</h6>
                          <i className="mdi mdi-percent-outline font-size-18" />
                        </Col>
                        <Col>
                          {!!featureClicks?.users_percentage
                            ? featureClicks?.users_percentage + "%"
                            : "-"}
                        </Col>
                      </Row>
                    </Card>
                  </Row>
                  <Row>
                    <Card
                      className="shadow-sm"
                      style={{
                        height: "115px",
                        border: "1px solid Gainsboro",
                      }}
                    >
                      <Row
                        className="d-flex align-items-center text-center"
                        style={{ height: "100%" }}
                      >
                        <Col xs="5">
                          <h6>Top User</h6>
                          <i className="mdi mdi-star font-size-18" />
                        </Col>
                        <Col>
                          {!!featureClicks?.top_user
                            ? featureClicks?.top_user?.display_name
                            : "-"}
                        </Col>
                      </Row>
                    </Card>
                  </Row>
                </Col>
                <Col xl="9">
                  <Row className="ms-4">
                    <Col>
                      <h6>Camera Views (last 7 days)</h6>
                    </Col>
                  </Row>
                  <Row className="ms-3" style={{ height: "500px" }}>
                    <Col>
                      <ResponsiveContainer>
                        <BarChart
                          data={
                            !!featureClicks
                              ? generateChartDataLastXDays(
                                  7,
                                  featureClicks?.views?.map(x => ({
                                    date: x?.date,
                                    value: x?.total_views,
                                  }))
                                )
                              : []
                          }
                          width={500}
                          height={500}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 15,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="date"
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dy={10}
                            label={{
                              value: "Date",
                              position: "bottom",
                            }}
                            angle={-20}
                          />
                          <YAxis
                            label={{
                              value: "# of Clicks",
                              angle: -90,
                              position: "insideLeft",
                            }}
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dx={-10}
                            allowDecimals={false}
                          />
                          <Tooltip
                            cursor={{ fill: "rgb(220, 220, 220, 0.5)" }}
                          />
                          <Bar
                            dataKey="value"
                            name="Total Clicks"
                            fill="#556ee6"
                            maxBarSize={50}
                            label={props => {
                              return (
                                <text
                                  x={props?.x}
                                  y={props?.y}
                                  dy={-15}
                                  dx={25}
                                  fontSize={14}
                                  textAnchor="middle"
                                >
                                  {props?.value > 0 ? "" : "No Views"}
                                </text>
                              )
                            }}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card> */}
          {!!featureViewsByUser && (
            <UserList
              event_id={event_id}
              feature_name="camera"
              report_name="Camera Report"
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  featureClicks: state.Analytics.featureClicks,
  featureViewsByUser: state.Analytics.featureViewsByUser,
})

const mapDispatchToProps = dispatch => ({
  getFeatureClicks: values => dispatch(getFeatureClicks(values)),
  resetFeatureClicks: () => dispatch(resetFeatureClicks()),
  getFeatureViewsByUser: values => dispatch(getFeatureViewsByUser(values)),
  resetFeatureViewsByUser: () => dispatch(resetFeatureViewsByUser()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CameraReport))
